<ng-lottie [options]="options" [styles]="styles"></ng-lottie>

<!-- height="500px" -->
